// export const baseUrl = "https://my-commerce-backend.herokuapp.com";
// export const baseUrl = "https://web-production-58f3.up.railway.app";
export const baseUrl = "https://ecommerce-backend-1ztr.onrender.com";